import lodashGet from 'lodash/get';
import { api } from '@/api/api';
import ContactSelectNotify from './contact_select_notify';
import { apis, inWindow } from '@/config';
import { util } from '@/api/util/index';
import { ContactDBInstance } from './contact_dbl';
import { ContactServerInstance } from './contact_server';
import { SequenceHelper } from '@/api/commonModel';
import { contactCommonConditionFilterName, contactCommonSearchFilterName, contactCommonTypeFilter, contactExcludeSelfFilterName, contactIMFilterName, contactMultiTypeFilterName, contactOrgIdEqTeamFilterName, contactOrgIdNeqPersonOrgFilterName, contactOrgIdNeqTeamFilterName, contactGrepRelateEnterpriseFilterName, contactGrepInvalidEnterpriseFilterName, } from '@/api/logical/contact_constants';
import { ContactEdmHelperInstance } from './contact_edm_help';
import { ContactCollegeHelperInstance } from './contact_college_help';
import { ContactPersonalHelperInstance } from './contact_personal_help';
import ContactUtilInterface from './contact_util';
import { ContactTransformInstance } from './contact_transform';
import { ContactSyncInstance } from './contact_sync';
import { contactSearchDbName } from './util/const';
import { ContactImplPersonal } from './contact_impl_personal';
import { ContactImplEnterprise } from './contact_impl_enterprise';
import { ContactImplSearch } from './contact_impl_search';
import { ContactImplRecent } from './contact_impl_recent';
import { ContactImplMark } from './contact_impl_mark';
class Action {
    constructor() {
        this.searchSeqGen = new SequenceHelper();
        this.searchContactSeq = this.searchSeqGen.next();
    }
}
export class ContactImplApi {
    constructor() {
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.dbApi = api.getNewDBApi();
        this.lokiApi = api.requireLogicalApi(apis.dbMemoryApiImpl);
        this.initData = {
            orgs: {},
            personal: [],
        };
        this.action = new Action();
        this.contactDB = ContactDBInstance;
        this.contactServer = ContactServerInstance;
        this.contactSync = ContactSyncInstance;
        this.contactSelectNotify = ContactSelectNotify;
        this.contactEdmHelper = ContactEdmHelperInstance;
        this.contactCollegeHelper = ContactCollegeHelperInstance;
        this.contactUtil = ContactUtilInterface;
        this.contactTrans = ContactTransformInstance;
        this.contactPersonalHelper = ContactPersonalHelperInstance;
        this.name = apis.contactApiImpl;
        this.store = api.getDataStoreApi();
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.http = api.getDataTransApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.dataTracker = api.requireLogicalApi('dataTrackerApiImp');
        this.errorReportImpl = api.requireLogicalApi('errorReportImpl');
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.nimApi = api.requireLogicalApi(apis.imApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.productApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.mailPlusCustomerApi = api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
        this.mailPraiseApi = api.requireLogicalApi(apis.mailPraiseApiImpl);
        this.initSubModules();
    }
    initSubModules() {
        const ctx = {
            facade: this,
            systemApi: this.systemApi,
            eventApi: this.eventApi,
            dbApi: this.dbApi,
            http: this.http,
            store: this.store,
            mailApi: this.mailApi,
            loggerApi: this.loggerApi,
            dataTracker: this.dataTracker,
            errorReportImpl: this.errorReportImpl,
            nimApi: this.nimApi,
            performanceApi: this.performanceApi,
            productApi: this.productApi,
            accountApi: this.accountApi,
            mailPlusCustomerApi: this.mailPlusCustomerApi,
            mailPraiseApi: this.mailPraiseApi,
            contactDB: this.contactDB,
            contactServer: this.contactServer,
            contactSync: this.contactSync,
            contactEdmHelper: this.contactEdmHelper,
            contactCollegeHelper: this.contactCollegeHelper,
            contactUtil: this.contactUtil,
            contactTrans: this.contactTrans,
            contactPersonalHelper: this.contactPersonalHelper,
            contactSelectNotify: this.contactSelectNotify,
            eventHub: this.contactSync.eventHub,
            lokiApi: this.lokiApi,
        };
        this._personal = new ContactImplPersonal(ctx);
        this._enterprise = new ContactImplEnterprise(ctx);
        this._search = new ContactImplSearch(ctx);
        this._recent = new ContactImplRecent(ctx);
        this._mark = new ContactImplMark(ctx);
    }
    async doGetPersonalOrg(params) {
        return this._personal.doGetPersonalOrg(params);
    }
    doInsertPersonalOrg(params) {
        return this._personal.doInsertPersonalOrg(params);
    }
    doUpdatePersonalOrg(params) {
        return this._personal.doUpdatePersonalOrg(params);
    }
    async doInsertContactByPersonalOrgId(params) {
        return this._personal.doInsertContactByPersonalOrgId(params);
    }
    async doDeletePersonalOrg(params) {
        return this._personal.doDeletePersonalOrg(params);
    }
    async doGetPersonalOrgContactByOrgId(params) {
        return this._personal.doGetPersonalOrgContactByOrgId(params);
    }
    async doGetPersonalNoGroupContact(_account) {
        return this._personal.doGetPersonalNoGroupContact(_account);
    }
    async doGetPersonalContact(option) {
        return this._personal.doGetPersonalContact(option);
    }
    async doUpdateContact(_params) {
        return this._personal.doUpdateContact(_params);
    }
    async doDeleteContact(params) {
        return this._personal.doDeleteContact(params);
    }
    async doInsertContact(params) {
        return this._personal.doInsertContact(params);
    }
    doGetOrgContactListByContactId(idList) {
        return this._personal.doGetOrgContactListByContactId(idList);
    }
    async uploadIcon(params) {
        return this._personal.uploadIcon(params);
    }
    async deleteAvatarIcon() {
        return this._personal.deleteAvatarIcon();
    }
    async doImportPersonalContact(params) {
        return this._personal.doImportPersonalContact(params);
    }
    async doExportPersonalContact(params) {
        return this._personal.doExportPersonalContact(params);
    }
    async doExportPersonalContactTemplate(type) {
        return this._personal.doExportPersonalContactTemplate(type);
    }
    async doGetContactReadySync(source) {
        return this._enterprise.doGetContactReadySync(source);
    }
    doGetLocalContactReady() {
        return this._enterprise.doGetLocalContactReady();
    }
    doGetContactLastUpdateTime(_account) {
        return this._enterprise.doGetContactLastUpdateTime(_account);
    }
    doGetOrgContactListByOrgId(idList, _account = this.contactUtil.getCurrentAccount()) {
        return this._enterprise.doGetOrgContactListByOrgId(idList, _account);
    }
    getContactSyncTimes() {
        return this._enterprise.getContactSyncTimes();
    }
    getContactSyncState(type = 'contact') {
        return this._enterprise.getContactSyncState(type);
    }
    getSyncTracker() {
        return this.contactSync.tracker;
    }
    getEnterpriseConfig(_account) {
        return this.contactSync.getEnterpriseConfig(_account);
    }
    async doGetContactByEmails(_emails = [], type) {
        return this._enterprise.doGetContactByEmails(_emails, type);
    }
    async doGetContactOrg(option) {
        return this._enterprise.doGetContactOrg(option);
    }
    async doGetContactOrgMap(params) {
        return this._enterprise.doGetContactOrgMap(params);
    }
    doGet(orgId, level) {
        return this._enterprise.doGet(orgId, level);
    }
    async doGetContactByQiyeAccountId(query) {
        return this._enterprise.doGetContactByQiyeAccountId(query);
    }
    async doGetContactById(id, _account = this.contactUtil.getCurrentAccount()) {
        return this._enterprise.doGetContactById(id, _account);
    }
    doGetFullContactByIdWithCallback(options) {
        this._enterprise.doGetFullContactByIdWithCallback(options);
    }
    async doGetOrgList(option = {}) {
        return this._enterprise.doGetOrgList(option);
    }
    async doGetTeamList(list) {
        return this._enterprise.doGetTeamList(list);
    }
    async doGetContactByOrgIds(orgIdList, _account = this.contactUtil.getCurrentAccount()) {
        return this._enterprise.doGetContactByOrgIds(orgIdList, _account);
    }
    async doGetServerContactByOrgIds(orgIdList, _account = this.contactUtil.getCurrentAccount()) {
        return this._enterprise.doGetServerContactByOrgIds(orgIdList, _account);
    }
    async doGetContactByOrgId(params) {
        return this._enterprise.doGetContactByOrgId(params);
    }
    transContactModel2ContactItem(item) {
        return this.contactUtil.transContactModel2ContactItem(item);
    }
    async getServerAndLocalContactByEmails(emails, _account) {
        return this._enterprise.getServerAndLocalContactByEmails(emails, _account);
    }
    async doGetContactByItem(_condition) {
        return this._enterprise.doGetContactByItem(_condition);
    }
    doGetVaildEmailByContact(pre, cur, isMainAccount) {
        return this._enterprise.doGetVaildEmailByContact(pre, cur, isMainAccount);
    }
    async doGetContactByEmailsAdvance(params) {
        return this._enterprise.doGetContactByEmailsAdvance(params);
    }
    async doGetContactByEmail({ emails, _account }) {
        return this._enterprise.doGetContactByEmail({ emails, _account });
    }
    async doGetContactByEmailInMemoryMode(params) {
        return this._enterprise.doGetContactByEmailInMemoryMode(params);
    }
    async doGetContactByEmailFilter({ emails, _account }) {
        return this._enterprise.doGetContactByEmailFilter({ emails, _account });
    }
    async doGetContactByYunxin(accounts) {
        return this._enterprise.doGetContactByYunxin(accounts);
    }
    async doGetServerContactByYunxin(accounts) {
        return this._enterprise.doGetServerContactByYunxin(accounts);
    }
    async doGetServerContactByEmails(emails, _account, uniqueEmail) {
        return this._enterprise.doGetServerContactByEmails(emails, _account, uniqueEmail);
    }
    doGetOrgContactListByIM(params) {
        return this._enterprise.doGetOrgContactListByIM(params);
    }
    async doGetOrgContactListByTeamId(params) {
        return this._enterprise.doGetOrgContactListByTeamId(params);
    }
    async doUpdateContactById(contact) {
        return this._enterprise.doUpdateContactById(contact);
    }
    async doUpdateContactModel(list) {
        return this._enterprise.doUpdateContactModel(list);
    }
    doInsertOrReplacePersonal(params) {
        return this._enterprise.doInsertOrReplacePersonal(params);
    }
    doGetAllContactList(account) {
        return this._enterprise.doGetAllContactList(account);
    }
    doGetAllOrgContact(account) {
        return this._enterprise.doGetAllOrgContact(account);
    }
    async doGetColleagueByOrgIds(params) {
        return this._enterprise.doGetColleagueByOrgIds(params);
    }
    async doGetColleagueList() {
        return this._enterprise.doGetColleagueList();
    }
    async doGetResignList() {
        return this._enterprise.doGetResignList();
    }
    doGetColleagueFolderList(id, emails) {
        return this._enterprise.doGetColleagueFolderList(id, emails);
    }
    async doGetColleaguePromotion() {
        return this._enterprise.doGetColleaguePromotion();
    }
    async doUpdateColleaguePromotion() {
        return this._enterprise.doUpdateColleaguePromotion();
    }
    async doSearchContactByAccounts(condition) {
        return this._search.doSearchContactByAccounts(condition);
    }
    async doSearchContactByAccountsInMemory(condition) {
        return this._search.doSearchContactByAccountsInMemory(condition);
    }
    async doSearchTeamContact(query, _account) {
        return this._search.doSearchTeamContact(query, _account);
    }
    doSearchAllContactNew(condition, onResult) {
        return this._search.doSearchAllContactNew(condition, onResult);
    }
    doSearchNew(condition, onResult) {
        return this._search.doSearchNew(condition, onResult);
    }
    async doSearchInMemory(condition) {
        return this._search.doSearchInMemory(condition);
    }
    async doGetContactByIdsNew(ids) {
        return this._search.doGetContactByIdsNew(ids);
    }
    async doSearch(condition) {
        return this._search.doSearch(condition);
    }
    async doSearchAllContactInMemory(condition) {
        return this._search.doSearchAllContactInMemory(condition);
    }
    async doSearchAllContact(_condition) {
        return this._search.doSearchAllContact(_condition);
    }
    async doCorpSearch(query, contactModelList) {
        return this._search.doCorpSearch(query, contactModelList);
    }
    async doSearchContact(query, isIM, noLock) {
        return this._search.doSearchContact(query, isIM, noLock);
    }
    doSearchServerYxContact(query, onResult) {
        this._search.doSearchServerYxContact(query, onResult);
    }
    async batchEnsureYunxinByIds(contactIds, account) {
        var _a;
        const _account = account || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this._search.batchEnsureYunxinByIds(contactIds, _account);
    }
    async handlePushCustomerMgs(params) {
        this.contactEdmHelper.handlePushCustomerMgs(params);
    }
    async syncAllAccount(force) {
        var _a;
        const eventHub = this.contactSync.eventHub;
        eventHub.onSubAccountAdded((e) => {
            const { subAccount } = e.eventData;
            this.contactSync.setContactSync({
                isMainAccount: false,
                _account: subAccount,
                force: false,
            });
        });
        eventHub.onSubAccountDeleted((e) => {
            var _a;
            const subAccount = (_a = e.eventData) === null || _a === void 0 ? void 0 : _a.subAccount;
            if (subAccount) {
                this.contactSync.destroyCoordinator(subAccount);
            }
        });
        eventHub.onSubAccountLoginExpired((e) => {
            var _a;
            const subAccount = (_a = e.eventData) === null || _a === void 0 ? void 0 : _a.subAccount;
            if (subAccount) {
                this.contactSync.destroyCoordinator(subAccount);
            }
        });
        if (this.systemApi.isMainPage()) {
            eventHub.onDetectContactException((e) => {
                var _a, _b, _c;
                const type = (_a = e.eventData) === null || _a === void 0 ? void 0 : _a.type;
                const enableSkipFullSync = ((_b = e.eventData) === null || _b === void 0 ? void 0 : _b.enableSkipFullSync) || false;
                if (type === 'contactNotEqualContactItem' || type === 'addressRuleChanged') {
                    this.contactSync.setContactSync({
                        isMainAccount: true,
                        _account: ((_c = this.systemApi.getCurrentUser()) === null || _c === void 0 ? void 0 : _c.id) || '',
                        force: true,
                        enableSkipFullSync,
                    });
                    this.dataTracker.track('pc_contact_needsyncall', { type });
                }
            }, { _account: (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id });
        }
        const accounts = await this.accountApi.getMainAndSubAccounts({ expired: false });
        return Promise.allSettled(accounts.map((account) => {
            var _a;
            return this.contactSync.setContactSync({
                isMainAccount: account.id === ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id),
                _account: account.id,
                force: force || false,
            });
        }));
    }
    async getRecentContactList(params, noCache) {
        return this._recent.getRecentContactList(params, noCache);
    }
    async addRecentContact(params) {
        return this._recent.addRecentContact(params);
    }
    async addFrequentContact(params) {
        return this._recent.addFrequentContact(params);
    }
    getMaillistMember(accountName) {
        return this._recent.getMaillistMember(accountName);
    }
    async createMaillist(params) {
        return this._recent.createMaillist(params);
    }
    async updateMaillist(params) {
        return this._recent.updateMaillist(params);
    }
    async deleteMaillist(params) {
        return this._recent.deleteMaillist(params);
    }
    listUserDomain() {
        return this._recent.listUserDomain();
    }
    listUserMaillist(type) {
        return this._recent.listUserMaillist(type);
    }
    getMaillist(getMailListParams) {
        return this._recent.getMaillist(getMailListParams);
    }
    getMaillistConfig() {
        return this._recent.getMaillistConfig();
    }
    checkMaillistAccountName(mailListMember) {
        return this._recent.checkMaillistAccountName(mailListMember);
    }
    async doGetContactInMailList(params) {
        var _a;
        const { idList, emailList } = params;
        const mainAccount = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        if (!(idList === null || idList === void 0 ? void 0 : idList.length) && !(emailList === null || emailList === void 0 ? void 0 : emailList.length)) {
            return Promise.reject(new Error('必须传入idList 或者emailList'));
        }
        const idSet = new Set(idList || []);
        const idMailMap = new Map();
        if (emailList === null || emailList === void 0 ? void 0 : emailList.length) {
            const memoryModels = await this.contactDB.getContactsInMemoryMode({
                type: 'email',
                fields: emailList,
                _account: mainAccount,
            });
            memoryModels.forEach(item => {
                if (item.type === 'enterprise') {
                    idMailMap.set(item.id, item.accountName);
                    idSet.add(item.id);
                }
            });
        }
        const orgContactList = (await this.lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'anyOf',
                field: 'contactId',
                args: [[...idSet]],
            },
            _dbAccount: mainAccount,
        }));
        const orgIdMap = new Map();
        (orgContactList || []).forEach(item => {
            if (item.orgId.startsWith('team_') || item.orgId.startsWith('personal_org_'))
                return;
            const contactIdList = orgIdMap.get(item.orgId) || [];
            contactIdList.push(item.contactId);
            orgIdMap.set(item.orgId, contactIdList);
        });
        const orgList = await this.contactDB.getOrgList({
            idList: [...orgIdMap.keys()],
            _account: mainAccount,
        });
        const idResult = {};
        const mailResult = {};
        orgList.forEach(item => {
            const contactIdList = orgIdMap.get(item.id);
            contactIdList === null || contactIdList === void 0 ? void 0 : contactIdList.forEach(contactId => {
                const inMailList = item.type === 2;
                const mail = idMailMap.get(contactId);
                const inIdList = idList === null || idList === void 0 ? void 0 : idList.includes(contactId);
                if (inMailList) {
                    if (mail) {
                        mailResult[mail] = true;
                    }
                    if (inIdList) {
                        idResult[contactId] = true;
                    }
                }
                else {
                    if (mail && !mailResult[mail]) {
                        mailResult[mail] = false;
                    }
                    if (inIdList && !idResult[contactId]) {
                        idResult[contactId] = false;
                    }
                }
            });
        });
        emailList === null || emailList === void 0 ? void 0 : emailList.forEach(item => {
            if (!mailResult[item]) {
                mailResult[item] = false;
            }
        });
        return { id: idResult, mail: mailResult };
    }
    isMailListByAccountType(type) {
        return type === 0 || type === 4;
    }
    doGetTableCount(tableName) {
        var _a;
        const _dbAccount = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.lokiApi.getTableCount({
            dbName: contactSearchDbName,
            tableName,
            _dbAccount,
        });
    }
    doGetModelDisplayEmail(model) {
        return this.contactUtil.doGetModelDisplayEmail(model);
    }
    contactLog(key, data) {
        return this.contactUtil.contactLog(key, data);
    }
    getColor(email) {
        return util.getColor(email);
    }
    getUserMedals() {
        setTimeout(() => {
            try {
                this.mailPraiseApi.initCurrentUserPendantId();
            }
            catch (error) {
                console.error('[contact] getUserMedals', error);
            }
        }, 2000);
    }
    async doGetPersonalMarkList(args = [], field = 'value', options, _account) {
        return this._mark.doGetPersonalMarkList(args, field, options, _account);
    }
    async doGetContactPersonalMarkList() {
        return this._mark.doGetContactPersonalMarkList();
    }
    async doBatchOperatePersonalMark(params, action = 'add') {
        return this._mark.doBatchOperatePersonalMark(params, action);
    }
    doGetPersonalMarklistByEmail(params) {
        return this._mark.doGetPersonalMarklistByEmail(params);
    }
    doUpdateMarkUnreadMailCount(idMap) {
        return this._mark.doUpdateMarkUnreadMailCount(idMap);
    }
    detectCoreEnterpriseHasData(from) {
        return this._mark.detectCoreEnterpriseHasData(from);
    }
    findContactInfoVal(contactInfoList, type) {
        return this._mark.findContactInfoVal(contactInfoList, type);
    }
    queryPersonalMemberCount(ids, account) {
        return this._mark.queryPersonalMemberCount(ids, account);
    }
    async deleteTrashContactByManual() {
        try {
            await this.contactSync.resetPersonalSyncState();
        }
        catch (e) {
            console.error('[contact_impl] deleteTrashContactByManual: resetPersonalSyncState failed', e);
        }
        try {
            this.contactSync.clearEnterpriseConfigStores();
        }
        catch (e) {
            console.error('[contact_impl] deleteTrashContactByManual: clearEnterpriseConfigStores failed', e);
        }
        return this._mark.deleteTrashContactByManual();
    }
    afterLogin(ev) {
        if (ev && ev.data) {
            this.contactDB.init();
            process.env.BUILD_ISEDM && this.contactEdmHelper.initDB();
            this.setContactNotifyListener();
            this.syncAllAccount().then(() => {
                this.getUserMedals();
            });
            ContactImplApi.inited = true;
            this.action = new Action();
        }
        return this.name;
    }
    beforeLogout() {
        this.contactServer.resetContact();
        this.contactSync.destroyAllCoordinators();
        this.clearSyncAll();
        ContactImplApi.inited = false;
        return this.name;
    }
    isInited() {
        return ContactImplApi.inited;
    }
    init() {
        this.http.addConfig({
            requestAutoReLogin(data) {
                return !!data.data && !!data.data.code && String(data.data.code) === '401';
            },
            reLoginUrlHandler: conf => conf,
            matcher: /^\/cowork\/api\/.*/i,
        });
        if (process.env.BUILD_ISEDM) {
            this.contactEdmHelper.addFilterRegistry();
        }
        this.lokiApi.addFilterRegistry({
            filterFunc: this.contactDB.getSearchFilter(),
            name: contactCommonSearchFilterName,
        });
        const commonFilter = (item, param) => { var _a; return item.type === ((_a = param === null || param === void 0 ? void 0 : param.additionalData) === null || _a === void 0 ? void 0 : _a.contactType); };
        this.dbApi.addFilterRegistry({
            filterFunc: commonFilter,
            name: contactCommonTypeFilter,
        });
        const contactCommonConditionFilter = (item, param) => {
            var _a, _b;
            return this.contactTrans.transInclude2FilterCondition((_a = param === null || param === void 0 ? void 0 : param.additionalData) === null || _a === void 0 ? void 0 : _a.includeOption, item) &&
                this.contactTrans.transExclude2FilterCondition((_b = param === null || param === void 0 ? void 0 : param.additionalData) === null || _b === void 0 ? void 0 : _b.excludeOption, item);
        };
        this.lokiApi.addFilterRegistry({
            filterFunc: contactCommonConditionFilter,
            name: contactCommonConditionFilterName,
        });
        const contactMultiTypeFilter = (item, param) => {
            var _a, _b, _c, _d;
            if (!((_a = param === null || param === void 0 ? void 0 : param.additionalData) === null || _a === void 0 ? void 0 : _a.type))
                return false;
            return item.contactItemType === ((_b = param === null || param === void 0 ? void 0 : param.additionalData) === null || _b === void 0 ? void 0 : _b.type) && (((_c = param === null || param === void 0 ? void 0 : param.additionalData) === null || _c === void 0 ? void 0 : _c.filterType) ? ((_d = param === null || param === void 0 ? void 0 : param.additionalData) === null || _d === void 0 ? void 0 : _d.filterType) === item.type : true);
        };
        this.dbApi.addFilterRegistry({
            filterFunc: contactMultiTypeFilter,
            name: contactMultiTypeFilterName,
        });
        const contactIMfilter = (item) => item.contactItemType === 'yunxin' && item.type === 'enterprise';
        this.dbApi.addFilterRegistry({
            filterFunc: contactIMfilter,
            name: contactIMFilterName,
        });
        const contactCommonPrefixFilterFactory = (prefix, equal) => (item) => (equal && item.orgId.startsWith(prefix)) || (!equal && !item.orgId.startsWith(prefix));
        const contactOrgIdEqTeamFilter = contactCommonPrefixFilterFactory('team_', true);
        this.dbApi.addFilterRegistry({
            filterFunc: contactOrgIdEqTeamFilter,
            name: contactOrgIdEqTeamFilterName,
        });
        const contactOrgIdNeqTeamFilter = contactCommonPrefixFilterFactory('team_', false);
        this.dbApi.addFilterRegistry({
            filterFunc: contactOrgIdNeqTeamFilter,
            name: contactOrgIdNeqTeamFilterName,
        });
        const contactOrgIdNeqPersonOrgFilter = contactCommonPrefixFilterFactory('personal_org_', false);
        this.dbApi.addFilterRegistry({
            filterFunc: contactOrgIdNeqPersonOrgFilter,
            name: contactOrgIdNeqPersonOrgFilterName,
        });
        const contactExcludeSelfFilter = (item, param) => { var _a, _b; return ((_a = param === null || param === void 0 ? void 0 : param.additionalData) === null || _a === void 0 ? void 0 : _a.contactId) && item.contactId !== ((_b = param === null || param === void 0 ? void 0 : param.additionalData) === null || _b === void 0 ? void 0 : _b.contactId); };
        this.dbApi.addFilterRegistry({
            filterFunc: contactExcludeSelfFilter,
            name: contactExcludeSelfFilterName,
        });
        const contactGrepInvalidEnterpriseFilter = (item) => {
            var _a;
            const contactType = lodashGet(item, 'type', '');
            if (contactType !== 'enterprise') {
                return true;
            }
            const mainEnterpriseId = (_a = this.systemApi.getCurrentCompanyId()) !== null && _a !== void 0 ? _a : 0;
            if (!mainEnterpriseId) {
                return true;
            }
            return item.enterpriseId === mainEnterpriseId;
        };
        this.lokiApi.addFilterRegistry({
            filterFunc: contactGrepInvalidEnterpriseFilter,
            name: contactGrepInvalidEnterpriseFilterName,
        });
        const contactGrepRelateEnterpriseFilter = (item, param) => {
            var _a;
            const field = lodashGet(param, 'additionalData.enterpriseFieldName', '');
            const needGrepRelateEnterpriseResult = lodashGet(param, 'additionalData.needGrepRelateEnterpriseResult', false);
            const myEnterpriseId = (_a = this.systemApi.getCurrentCompanyId()) !== null && _a !== void 0 ? _a : 0;
            if (!field || !needGrepRelateEnterpriseResult || !myEnterpriseId) {
                return true;
            }
            return !item[field] || `${item[field]}` === `${myEnterpriseId}`;
        };
        this.lokiApi.addFilterRegistry({
            filterFunc: contactGrepRelateEnterpriseFilter,
            name: contactGrepRelateEnterpriseFilterName,
        });
        return this.name;
    }
    onPathChange(ev) {
        console.log('[contact] onPathChange', ev);
        return this.name;
    }
    afterInit() {
        this.contactSync.eventHub.onContactOrgNotify(ev => {
            var _a;
            const account = (_a = ev._account) !== null && _a !== void 0 ? _a : this.contactUtil.getCurrentAccount();
            this._enterprise.clearOrgCache(account);
        });
        this.contactDB.contactSyncTimes = 0;
        const currentUser = this.systemApi.getCurrentUser();
        console.log('[contact] afterInit', currentUser);
        if (currentUser) {
            this.contactDB.init();
            process.env.BUILD_ISEDM && this.contactEdmHelper.initDB();
            this.setContactNotifyListener();
            if (this.contactSync.enableSync()) {
                this.syncAllAccount();
            }
            else {
                this.contactSync
                    .ensureDataReady({
                    _account: currentUser.id,
                    isMainAccount: true,
                })
                    .catch(ex => {
                    console.error('[contact] afterInit ensureDataReady failed', ex);
                });
            }
        }
        if (!ContactImplApi.inited) {
            ContactImplApi.inited = true;
        }
        return this.name;
    }
    setContactNotifyListener() {
        if (inWindow() && this.systemApi.isMainWindow()) {
            this.contactSync.eventHub.onContactNotify(e => {
                this.contactDB.setContactLastUpdateTime(e._account);
            });
        }
    }
    setEDMSync() {
        if (!0) {
            throw new Error('no support');
        }
        setTimeout(() => {
            this.contactSync.setCustomerContactSync();
        }, 50);
    }
    clearSyncAll() {
        this.contactSync.clearSyncAll();
    }
}
ContactImplApi.inited = false;
export const contactImpl = new ContactImplApi();
const addMethodProxy = (methodList, contactImpl, handler) => {
    methodList.forEach(method => {
        contactImpl[method] = new Proxy(contactImpl[method], {
            apply: async (target, context, args) => {
                const res = await target.apply(context, args);
                handler(method, res);
                return res;
            },
        });
    });
    return contactImpl;
};
const newContactImpl = addMethodProxy(ContactSelectNotify.selectWhiteList, contactImpl, ContactSelectNotify.handleNeedTransData.bind(ContactSelectNotify));
api.registerLogicalApi(newContactImpl);
export default newContactImpl;
